import React from "react";
import Typography from "@material-ui/core/Typography";
import { GridToolbarContainer, GridToolbarExport } from "@material-ui/data-grid";

import classes from "./SegmentsLogs.module.scss";

const SegmentsLogsDashboardToolbar = () => {
  return (
    <GridToolbarContainer className={classes.dashboardControls}>
      <Typography>Segments Logs</Typography>
      <GridToolbarExport />
    </GridToolbarContainer>
  );
};

export default SegmentsLogsDashboardToolbar;
